var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"st-pusher"},[_c('div',{staticClass:"st-content"},[_c('div',{staticClass:"st-content-inner"},[_c('div',{ref:"main",staticClass:"main clearfix"},[(!_vm.isMobileApp)?_c('TopHeader'):_vm._e(),(!_vm.isMobileApp && !_vm.is404Page && !_vm.noBanner && !_vm.isFooterPage)?_c('TopNav'):_vm._e(),_c('router-view')],1)])])])
}
var staticRenderFns = []

export { render, staticRenderFns }